// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__SLHvm","unreadBadge":"styles_unreadBadge__3PEHI","modalContent":"styles_modalContent__20dtb","modal":"styles_modal__Q24CP"};